import { routeUrls } from './routeUrls';

// Tipi per le chiamate API disponibili
export type ApiCallType = 
  | 'services' 
  | 'servicesInfo' 
  | 'fleet' 
  | 'routes' 
  | 'roles' 
  | 'notifications' 
  | 'businessProfile' 
  | 'countries'
  | 'documents';

// Configurazione delle chiamate API per ogni route
export const apiCallConfig: Record<string, ApiCallType[]> = {
  // Dashboard - ora gestisce le chiamate API direttamente nel componente
  [routeUrls.dashboard]: [
    // Tutte le chiamate sono state spostate direttamente nel componente Dashboard
  ],

  // Services - carica solo i dati dei servizi
  [routeUrls.services]: [
    'services',
    'servicesInfo',
 //   'countries'
  ],

  // Documents - carica solo i dati necessari per i documenti
  [routeUrls.documents]: [
    'businessProfile',
    'countries'
  ],

  // Contracts - carica solo i dati necessari per i contratti
  [routeUrls.contracts]: [
    'businessProfile',
   // 'countries'
  ],

  // Fleet and Route - carica i dati della flotta e delle route
  [routeUrls.fleetAndRoute]: [
    'fleet',
    'routes',
    'countries',
    'businessProfile'
  ],

  // Settings - carica i dati delle impostazioni
  [routeUrls.settings]: [
    'roles',
    'businessProfile',
   // 'countries'
  ],

  // Profile - carica i dati del profilo
  [routeUrls.profile]: [
    'businessProfile',
  //  'countries'
  ],

  // Trips - carica i dati dei viaggi
  [routeUrls.trips]: [
    'businessProfile',
   // 'countries'
  ],

  // Trip details - carica i dati specifici del viaggio
  [routeUrls.trip]: [
    'businessProfile',
  //  'countries'
  ],

  // Trip documents - carica i dati dei documenti del viaggio
  [routeUrls.tripDocuments]: [
    'businessProfile',
   // 'countries'
  ],
  [routeUrls.documents]: [
    'businessProfile',
    'documents'
   // 'countries'
  ]
};

// Funzione helper per ottenere le chiamate API necessarie per un path
export const getApiCallsForPath = (pathname: string): ApiCallType[] => {
  // Gestisci i path con parametri dinamici
  if (pathname.includes('/tripdetails/')) {
    if (pathname.includes('/documents')) {
      return apiCallConfig[routeUrls.tripDocuments];
    }
    return apiCallConfig[routeUrls.trip];
  }
  
  // Cerca il path esatto
  if (apiCallConfig[pathname]) {
    return apiCallConfig[pathname];
  }
  
  // Fallback: ritorna le chiamate del dashboard se non trova nulla
  return apiCallConfig[routeUrls.dashboard];
};

// Funzione per verificare se una chiamata API è necessaria per il path corrente
export const isApiCallNeeded = (apiCall: ApiCallType, pathname: string): boolean => {
  const neededCalls = getApiCallsForPath(pathname);
  return neededCalls.includes(apiCall);
}; 